import Update_Icon from "../images/table/Update_icon.svg";
import Track_Icon from "../images/table/View_icon.svg";
import Delete_Icon from "../images/table/Delete_icon.svg";

export const FLEET_STOP_ROW_ACTIONS = {
  updateStop: {
    id: "update",
    label: "Update",
    icon: Update_Icon,
    path: "/stops/edit",
    permission: { apiPath: "/api/stop", action: "PUT" },
  },
  monitorStop: {
    id: "view",
    label: "Monitor",
    icon: Track_Icon,
    path: "/stops/view",
    permission: { apiPath: "/api/stop/id", action: "GET" },
  },
  deleteStop: {
    id: "delete",
    label: "Delete",
    className: "delete",
    icon: Delete_Icon,
    path: "",
    permission: { apiPath: "/api/stop", action: "DELETE" },
  },
};

export function computeFleetStopMetric(metricKey, stopsData = []) {
  const stops = Array.isArray(stopsData) ? stopsData : [];

  switch (metricKey) {
    case "totalStops":
      return stops.length;
    case "activeStops":
      return stops.filter((stop) =>
        Array.isArray(stop.routes) ? stop.routes.length > 0 : Boolean(stop.routeId),
      ).length;
    case "connectedRoutes":
      return new Set(
        stops.flatMap((stop) =>
          Array.isArray(stop.routes) ? stop.routes.map((route) => route.id) : [],
        ),
      ).size;
    case "avgDwellTime":
      return stops.avgDwellLabel || "00m 00s";
    default:
      return 0;
  }
}
